<template>
	<div class="c-pendings c-notifications"
        :data-component-name="$options.name"
    >
        <div class="c-notifications-subheader -hidden-mobile"
            v-if="!loading"
        >
            <div class="row full-width align-content-center">
                <div class="cursor-pointer" @click="refresh()">
                    <q-icon name="refresh" size="14px" class="q-mr-xs" /> Rafraichir
                </div>
            </div>
        </div>
        <div class="c-notifications-subheader -hidden-mobile"
            v-else-if="loading"
        >
            <div>
                <q-spinner
                    color="primary"
                    class="q-mr-xs"
                />
                Chargement en cours
            </div>
        </div>
        <div class="c-notifications-row -list-header -hidden-mobile"
        >
            <div class="c-notifications-content">
                <div class="c-notifications-avatar">
                    De
                </div>
                <div class="-from">
                </div>
                <div class="-subject">
                    Nom du projet
                </div>
                <div class="-period text-center">
                    Période
                </div>
                <div class="-assignmentsCount text-center">
                    Affectactions
                </div>
                <div class="-date">
                    Modifié
                </div>
            </div>
        </div>
        <div class="c-notifications-row no-notifs"
            v-if="!loading && projectsInbox.data && projectsInbox.data.length==0"
        >
            Aucune affectation en attente
        </div>
        <div class="c-notifications-row__wrap -snap-enable"
            v-else-if="projectsInbox"
            ref="js-notifications-list"
            @scroll.passive="onNotificationsScroll()"
        >
            <PendingAssignments
                :isMobile="isMobile"
                :key="index"
                :index="index"
                v-for="(project, index) in projectsInbox.data"
                :project="project"
                :userProfile="userProfile"
                class="c-notifications-row -scrollable"
                @is-loading="loading=$event"
            />
            <div class="c-notifications-row -loading" v-if="projectsInbox.paginatorInfo && projectsInbox.paginatorInfo.hasMorePages">
                <div v-if="!loading" ref="js-notifications-actions" @click="onNotificationsScroll()">Plus de résultats...</div>
                <div v-else>
                    <q-spinner
                        color="primary"
                        size="1em"
                        class="q-mr-xs"
                    />
                    Chargement en cours...
                </div>
            </div>
            <div class="c-notifications-row -spacer">
            </div>
        </div>

        <!-- <pre> {{ projectsInbox }} </pre> -->
	</div>
</template>

<script>
    // import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
	import { PROJECTSINBOX } from "@/graphql/notification/queries";
    import PendingAssignments from '@/components/notifications/PendingAssignments'
    // import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"

    export default {
        name: 'Pending',
        components: {
            PendingAssignments
        },
        props: {
            userProfile: {
                type: Object,
                default(){
                    return null
                }
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data(){
        	return {
                pageSize: 15,
                loading: true,
                myUserProfile: window.myUserProfile,
        	}
        },
        mounted(){
            this.$emit('change-inbox', this.myUserProfile)
            // alert('pending')
			// this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
        },
        //computed: {},
        watch: {
            loading(){
                if(this.loading===false) this.$emit('schedule-loaded')
            }
        },
        methods: {
            refresh(){
                // alert('refresh')
                this.$apollo.queries.projectsInbox.refetch()
            },
            onNotificationsScroll(){
                if(!this.projectsInbox?.paginatorInfo?.hasMorePages) return;
                this.notificationScrollTo=setTimeout(function(){
                    var loadMoreEl = this.$refs["js-notifications-actions"];
                    var loadMoreParent = this.$refs["js-notifications-list"];
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = loadMoreParent.getBoundingClientRect().height+loadMoreParent.getBoundingClientRect().top;
                        if ((marginTop < innerHeight) && !this.loading) {
                            this.getMoreNotifications();
                        }
                    }
                }.bind(this), 300);
            },
            getMoreNotifications(){
                let page=this.projectsInbox.paginatorInfo.currentPage+1;
                this.$apollo.queries.projectsInbox.fetchMore({
                    variables: {
                        page: page,
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            projectsInbox: {
                                __typename: previousResult.projectsInbox.__typename,
                                data: [...previousResult.projectsInbox.data, ...fetchMoreResult.projectsInbox.data],
                                paginatorInfo: fetchMoreResult.projectsInbox.paginatorInfo,
                            }
                        }

                    }
                })
            }
        },
        apollo: {
			projectsInbox: {
				query: PROJECTSINBOX,
				fetchPolicy: 'network-only',
				error(error){
					if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
				},
				variables() {
					return {
						userProfileID: this.userProfile.id,
						page: 1,
                        first: this.pageSize,
					}
				},
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
				update(data) {
					// if(!this.updateQuery){
					// 	data.projectsInbox.data.forEach(function(project){
					// 		project.userAssignments=[];
					// 	})
					// }
					// this.onDocumentScroll()
					// return data.projectsInbox
                    return data.projectsInbox
				},
			}
        }
    }
</script>

<style lang="scss">
	@import "@/scss/views/Dashboard.scss";
    @import "@/scss/components/dashboard/Inbox.scss";
    @import "@/scss/components/assignments/AssignmentsV2.scss";
</style>